import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Box, Card, Flex } from "rebass";
import { RouteComponentProps } from "react-router-dom";

import { getIsAnonymous } from "../../../store/modules/session/selectors";

import { CloseButton } from "../../components/CloseButton";

import { Aside } from "./Aside";
import { Main } from "./Main";

export type IProps = RouteComponentProps<any, any, undefined | { prevLocation: string }>;

export const SettingsPage: React.FC<IProps> = ({ history, location, match }) => {
  const [prevLocation, setPrevLocation] = useState("/");
  const isAnonymous = useSelector(getIsAnonymous);
  const isLogin = isAnonymous === false;

  const closeSettings = useCallback((event: React.MouseEvent) => {
    event.preventDefault();

    history.push(prevLocation);
  }, [history, prevLocation]);

  useEffect(() => {
    const { state } = location;

    if (state) {
      const { prevLocation } = state;

      setPrevLocation(prevLocation);
    }
  }, [location]);

  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      css="position: fixed; top: 0; right: 0; bottom: 0; left: 0; z-index: 10;"
    >
      <Box
        backgroundColor="rgba(0,0,0,.42)"
        css="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"
        {...(isLogin ? { onClick: closeSettings } : {})}
      />

      <Box css="position: absolute; width: 90%; height: 90%; max-width: 1046px; max-height: 731px;">
        <Card
          width="100%"
          height="100%"
          borderRadius="5px"
          css="overflow: hidden;"
        >
          <Flex height="100%">
            <Card
              width={0.3}
              backgroundColor="white"
              borderRight="2px solid"
              borderRightColor="sp-gray"
            >
              <Aside match={match} isLogin={isLogin} />
            </Card>

            <Box
              flex={1}
              backgroundColor="sp-gray2"
            >
              <Main match={match} isLogin={isLogin} />
            </Box>
          </Flex>
        </Card>

        {
          isLogin && (
            <CloseButton onClick={closeSettings} />
          )
        }
      </Box>
    </Flex>
  );
};
